var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.step === _vm.stepTypes.OFFICE.toString()
        ? _c(
            "b-badge",
            { staticClass: "mr-2", attrs: { variant: "light-warning" } },
            [_vm._v(" Por asignar ")]
          )
        : _vm._e(),
      _vm.step === _vm.stepTypes.OFFICE.toString()
        ? _c(
            "b-avatar",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip",
                  value: "Por asignar",
                  expression: "'Por asignar'"
                }
              ],
              attrs: { rounded: "", size: "28", variant: "light-warning" }
            },
            [_c("feather-icon", { attrs: { size: "18", icon: "LoaderIcon" } })],
            1
          )
        : _vm._e(),
      _vm.step === _vm.stepTypes.OFFICER.toString()
        ? _c(
            "b-badge",
            { staticClass: "mr-2", attrs: { variant: "light-info" } },
            [_vm._v(" Asignado ")]
          )
        : _vm._e(),
      _vm.step === _vm.stepTypes.OFFICER.toString()
        ? _c(
            "b-avatar",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip",
                  value: "Asignado",
                  expression: "'Asignado'"
                }
              ],
              attrs: { rounded: "", size: "28", variant: "light-info" }
            },
            [
              _c("feather-icon", { attrs: { size: "18", icon: "ShuffleIcon" } })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }